import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { ContainerHero } from "./styled";

function Hero() {
  return (
    <ContainerHero
      style={{ padding: "0px", display: "flex", justifyContent: "center" }}
    >
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 hero"></div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div class="hero-text col-xs-9 col-md-12 col-sm-12 col-lg-12">
          <h1>
            HERRAMIENTAS PARA PERIODISTAS Y COMUNICADORES
            <br />
          </h1>
          <p>
            Una guía de páginas, apps y programas para ayudar a estudiantes y
            profesionales del periodismo y la comunicación.
          </p>
        </div>
      </div>
    </ContainerHero>
  );
}

export default Hero;
